import React, { useEffect } from 'react';
import { useT } from 'client/i18n/hooks/useT';
import { Footer } from '../../components/Footer';
import styles from './styles.sass';
import HermanNotFoundSVG from '../../components/svgs/HermanNotFound';
import trackEvent from '../../modules/analytics/trackEvent';
import { Button } from '../../shared/Button/NewButton';

const NotFoundScreen = ({ isLoggedIn, path, handleNotFound = () => {} }) => {
  const t = useT();
  useEffect(() => {
    handleNotFound(path);
  }, [handleNotFound, path]);
  return (
    <div className={styles.notFound} data-testid="404-page">
      <div className={styles.content}>
        <div className={styles.herman}>
          <HermanNotFoundSVG />
        </div>
        <div className={styles.textContainer}>
          {isLoggedIn ? (
            <>
              <h4 className={styles.header}>
                {t(
                  'NotFoundScreen.LoggedIn.Header',
                  "Sorry, we couldn't find the page you were looking for. Head back to your dashboard instead?",
                  'A logged in user has hit a page that does not exist. We ask if they want to head back to their dashboard instead'
                )}
              </h4>
              <Button kind="link" href="/dashboard" color="yellow">
                {t(
                  'NotFoundScreen.LoggedIn.DashboardAction',
                  'Go to dashboard',
                  'Action to take user to their dashboard screen'
                )}
              </Button>
            </>
          ) : (
            <>
              <h4 className={styles.header}>
                {t(
                  'NotFoundScreen.LoggedOut.HeaderOne',
                  'Well, this is embarrassing!',
                  'Someone has hit a page that does not exist and they are not a logged in user. We acknowledge our sites flaw'
                )}
                <br />
                {t(
                  'NotFoundScreen.LoggedOut.HeaderTwo',
                  "We couldn't find the page you were looking for...",
                  'Someone has hit a page that does not exist and they are not a logged in user. We acknowledge the page was not found'
                )}
              </h4>
              <p className={styles.copy}>
                {t(
                  'NotFoundScreen.LoggedOut.Body',
                  "But if you're looking to make a podcast of your own, that's something we can help you with.",
                  'Someone has hit a page that does not exist and they are not a logged in user. We offer to help them'
                )}
              </p>
              <Button
                kind="link"
                href="/"
                color="yellow"
                onClick={() => navigateToHomepage()}
              >
                {t(
                  'NotFoundScreen.LoggedOut.HomepageAction',
                  'Learn more about Anchor',
                  'Action to take user to the homepage'
                )}
              </Button>
            </>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );

  function navigateToHomepage() {
    trackEvent(
      null,
      {
        eventCategory: '404',
        eventAction: 'Click',
        eventLabel: 'Learn more about Anchor',
      },
      { providers: [ga] }
    );
  }
};

export default NotFoundScreen;
